import { render, staticRenderFns } from "./AssessmentEdit.vue?vue&type=template&id=12c7401c&"
import script from "./AssessmentEdit.vue?vue&type=script&lang=js&"
export * from "./AssessmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports